const GoogleIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" width="20" height="20">
    <path
      fill="#EA4335"
      d="M24 9.5c3.14 0 5.95 1.08 8.17 2.86l6.09-6.09C34.46 3.09 29.53 1 24 1 14.82 1 7.07 6.48 3.64 14.23l7.1 5.52C12.44 13.64 17.73 9.5 24 9.5z"
    />
    <path
      fill="#4285F4"
      d="M46.52 24.5c0-1.64-.15-3.22-.43-4.75H24v9h12.7c-.55 2.97-2.2 5.48-4.68 7.17l7.19 5.59C43.44 37.38 46.52 31.38 46.52 24.5z"
    />
    <path
      fill="#FBBC05"
      d="M10.74 28.25A14.6 14.6 0 0 1 9.5 24c0-1.48.25-2.91.74-4.25l-7.1-5.52A23.94 23.94 0 0 0 0 24c0 3.87.93 7.52 2.56 10.73l8.18-6.48z"
    />
    <path
      fill="#34A853"
      d="M24 47c5.53 0 10.17-1.83 13.56-4.97l-7.19-5.59C28.6 38.1 26.43 38.5 24 38.5c-6.27 0-11.56-4.14-13.26-9.75l-8.18 6.48C6.07 43.52 14.4 47 24 47z"
    />
    <path fill="none" d="M0 0h48v48H0z" />
  </svg>
);

export default GoogleIcon;
